import React, { useState } from 'react';
import styled from '@emotion/styled';
import Button from '~/App/Components/Button';
import ReportModal from './Modals/ReportModal';
import { reportGreet, reportRecording } from '~/App/Api/Report';
import { LandingPageType } from '~/types/redux/share';

const ReportButton = styled(Button)<Pick<ReportProps, 'showLabel'>>`
  align-items: center;
  display: flex !important;
  width: 45px;
  align-items: center;
  overflow: hidden;

  ${(props) => {
    if (props.showLabel) {
      return `
        width: auto;
        color: white !important;
        background: #d0577d !important;
      `;
    }
  }}
  &:hover {
    width: auto;
    color: white !important;
    background: #d0577d !important;
  }
`;

const ReportPage = styled.div`
  margin-left: 16px;
`;

export type ReportProps = {
  modelId: string;
  landingPageType: LandingPageType;
  className?: string;
  showLabel?: boolean;
};
export default function Report({
  modelId,
  className,
  showLabel,
  landingPageType,
}: ReportProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  function submitReport(reasonType: string, reasonText?: string) {
    const report =
      landingPageType === LandingPageType.Greet ? reportGreet : reportRecording;

    return report(modelId, {
      reason_type: reasonType,
      reason_text: reasonText,
    });
  }

  return (
    <>
      {isModalOpen && (
        <ReportModal
          onClose={() => setIsModalOpen(false)}
          onSubmit={submitReport}
          showModal
        />
      )}
      <ReportButton
        showLabel={showLabel}
        className={className}
        onClick={() => setIsModalOpen(true)}
      >
        <i className='fa fa-flag ic' />
        <ReportPage>Report this page</ReportPage>
      </ReportButton>
    </>
  );
}
